"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _qs = _interopRequireDefault(require("qs"));

var _axios = _interopRequireDefault(require("axios"));

var _interceptors = require("./interceptors");

var _agents = _interopRequireDefault(require("./agents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Base class for all Fabric API clients.
 */
var BaseApiClient = /*#__PURE__*/function () {
  /**
   * Initialise.
   */
  function BaseApiClient() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        baseURL = _ref.baseURL,
        mimeType = _ref.mimeType,
        getToken = _ref.getToken,
        refreshToken = _ref.refreshToken,
        _ref$debug = _ref.debug,
        debug = _ref$debug === void 0 ? true : _ref$debug,
        apiName = _ref.apiName,
        defaultHeaders = _ref.defaultHeaders,
        _ref$qsOptions = _ref.qsOptions,
        qsOptions = _ref$qsOptions === void 0 ? {
      arrayFormat: 'brackets'
    } : _ref$qsOptions;

    _classCallCheck(this, BaseApiClient);

    if (!baseURL) {
      throw new TypeError('A baseURL must be provided.');
    }

    var headers = defaultHeaders || {
      'Content-Type': 'application/json',
      accept: mimeType || 'application/json'
    };
    var axiosOpts = {
      baseURL: baseURL,
      headers: headers,
      // Needed to serialize params such as unixUpdated[gt]=123
      paramsSerializer: function paramsSerializer(params) {
        return _qs["default"].stringify(params, qsOptions);
      }
    }; // Keep sockets around even when there are no outstanding requests, so they
    // can be used for future requests without having to re-establish a TCP
    // connection.

    if (_agents["default"]) {
      axiosOpts.httpAgent = _agents["default"].httpAgent;
      axiosOpts.httpsAgent = _agents["default"].httpsAgent;
    }

    this.axios = _axios["default"].create(axiosOpts);
    this.setupInterceptors({
      getToken: getToken,
      refreshToken: refreshToken,
      debug: debug,
      apiName: apiName
    });
  }
  /**
   * Setup any request and response interceptors.
   */


  _createClass(BaseApiClient, [{
    key: "setupInterceptors",
    value: function setupInterceptors(_ref2) {
      var getToken = _ref2.getToken,
          refreshToken = _ref2.refreshToken,
          debug = _ref2.debug,
          apiName = _ref2.apiName;

      if (getToken) {
        this.setupGetTokenInterceptor({
          getToken: getToken
        });
      }

      if (refreshToken) {
        this.setupRefreshTokenInterceptor({
          refreshToken: refreshToken
        });
      }

      if (debug) {
        this.setupDebugInterceptors({
          apiName: apiName
        });
      }

      if (_agents["default"]) {
        this.setupEconnresetInterceptor();
      }
    }
    /**
     * Setup the refresh token interceptor.
     */

  }, {
    key: "setupRefreshTokenInterceptor",
    value: function setupRefreshTokenInterceptor(_ref3) {
      var refreshToken = _ref3.refreshToken;
      var interceptor = (0, _interceptors.refreshTokenInterceptor)({
        refreshToken: refreshToken
      });
      this.axios.interceptors.response.use(interceptor.success, interceptor.error);
    }
    /**
     * Setup the get token interceptor.
     */

  }, {
    key: "setupGetTokenInterceptor",
    value: function setupGetTokenInterceptor(_ref4) {
      var getToken = _ref4.getToken;
      var interceptor = (0, _interceptors.getTokenInterceptor)({
        getToken: getToken
      });
      this.axios.interceptors.request.use(interceptor.success, interceptor.error);
    }
    /**
     * Setup the debug interceptor.
     */

  }, {
    key: "setupDebugInterceptors",
    value: function setupDebugInterceptors(_ref5) {
      var apiName = _ref5.apiName;
      var requestInterceptor = (0, _interceptors.debugRequests)();
      var responseInterceptor = (0, _interceptors.debugResponses)({
        apiName: apiName
      });
      this.axios.interceptors.request.use(requestInterceptor.success, requestInterceptor.error);
      this.axios.interceptors.response.use(responseInterceptor.success, responseInterceptor.error);
    }
    /**
     * Setup the ECONNRESET interceptor.
     */

  }, {
    key: "setupEconnresetInterceptor",
    value: function setupEconnresetInterceptor() {
      var interceptor = (0, _interceptors.getEconnresetInterceptor)();
      this.axios.interceptors.response.use(interceptor.success, interceptor.error);
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(endpoint, options) {
        var res, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.request(endpoint, options);

              case 2:
                res = _context.sent;
                data = res.data;
                return _context.abrupt("return", data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x, _x2) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(endpoint, options) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.request(endpoint, _objectSpread(_objectSpread({}, options), {}, {
                  method: 'GET'
                })));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x3, _x4) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(endpoint, options) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.request(endpoint, _objectSpread(_objectSpread({}, options), {}, {
                  method: 'POST'
                })));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function post(_x5, _x6) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(endpoint, options) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.request(endpoint, _objectSpread(_objectSpread({}, options), {}, {
                  method: 'PUT'
                })));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function put(_x7, _x8) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(endpoint, options) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.request(endpoint, _objectSpread(_objectSpread({}, options), {}, {
                  method: 'DELETE'
                })));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete(_x9, _x10) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return BaseApiClient;
}();

exports["default"] = BaseApiClient;